import React, { useEffect, useState } from 'react';
import { Button, Alert } from 'react-bootstrap';
import Login from './login';
import SignUp from './signUp';
import { useNavigate, useLocation } from 'react-router-dom';

const AuthPage = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [secondsLeft, setSecondsLeft] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();

 const sessionExpired = location.state?.sessionExpired === true;

  useEffect(() => {
    if (sessionExpired) {
      setSecondsLeft(10);

      const interval = setInterval(() => {
        setSecondsLeft(prev => {
          if (prev === 1) {
            clearInterval(interval);
            navigate("/", { replace: true });
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [sessionExpired, navigate]);

  return (
    <div className="modal show d-block">
      <div className="modal-dialog" style={{ maxHeight: '80%', margin: 'auto', marginTop: '100px' }}>
        <div className="modal-content" style={{ backgroundColor: '#e6e8ec' }}>
          <div className="modal-header">
            <h5 className="modal-title">
              {sessionExpired ? 'Session Expired' : isLogin ? 'Login' : 'Sign Up'}
            </h5>
          </div>

          <div className="modal-body">

            {sessionExpired && (
              <Alert variant="warning">
                Your session has expired.  
                You will be redirected to the login page in {secondsLeft} seconds.
              </Alert>
            )}

            {!sessionExpired && (
              <>
                {isLogin ? <Login /> : <SignUp />}

                <div className="text-center mt-3">
                  {isLogin ? (
                    <p>
                      New here?{' '}
                      <Button variant="link" onClick={() => setIsLogin(false)}>
                        Sign Up
                      </Button>
                    </p>
                  ) : (
                    <p>
                      Already have an account?{' '}
                      <Button variant="link" onClick={() => setIsLogin(true)}>
                        Login
                      </Button>
                    </p>
                  )}
                </div>
              </>
            )}

          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthPage;
